import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Message, MessageService } from 'primeng/api';
import { LoginService } from '../login/login.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
  providers: [MessageService]
})
export class ResetPasswordComponent implements OnInit {

  msgs: Message[] = [];
  model: any = {};
  showSpinner = false;
  showToggle = false;
  validConfirmPassword = true;
  errorMessage: string;
  passwordToken: any = '';
  currentState: any = "wait";

  constructor(private router: Router,
    private messageService: MessageService,
    private loginService: LoginService) {
    this.verifyToken();
  }

  ngOnInit() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('login');
  }

  ngOnDestroy(): void {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('login');
  }

  passwordChanged() {
    if (this.model.newPassword != this.model.confirmPassword) {
      this.validConfirmPassword = false;
    }
    else {
      this.validConfirmPassword = true;
    }
  }

  updatePassword(updatePasswordData: any) {
    if (this.validConfirmPassword) {
      this.showSpinner = true;
      this.loginService.updatePassword(this.passwordToken, updatePasswordData).subscribe((result: any) => {
        this.showToggle = false;
        this.showSpinner = false;
        this.showSuccess(result.message);
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 2000);
      }, (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 422 || error.status == 400) {
            this.errorMessage = "The reset link is invalid or expired. Try requesting a new one.";
            this.showToggle = true;
          }
        }
        this.showSpinner = false;
      });
    }
  }

  verifyToken() {
    let url = window.location.href.split('/');
    this.passwordToken = url.pop();
    this.loginService.validatePasswordToken(this.passwordToken).subscribe((result: any) => {
      if (result.success) {
        this.model.email = result.email;
        this.currentState = "verified";
      } else {
        this.currentState = "notVerified";
      }
    }, (error) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 422 || error.status == 400) {
          this.currentState = "notVerified";
        }
      }
    });
  }

  closeErrorDiv() {
    this.showToggle = !this.showToggle;
  }

  showSuccess(message: string) {
    this.messageService.add({ severity: 'success', summary: 'Success', detail: message, life: 2500 });
  }

}
